// extracted by mini-css-extract-plugin
export var contentBody = "_3q-9";
export var headerImage = "_3q-2";
export var imageButton = "_3q-7";
export var imageButtonIcon = "_3q-8";
export var imageHeader = "_3q-4";
export var imageHeaderText = "_3q-5";
export var imageOverlay = "_3q-3";
export var imageTitle = "_3q-6";
export var imageWrapper = "_3q-1";
export var taskList = "_3q-a";
export var widget = "_3q-0";